export default __webpack_public_path__ + "static/media/i231hk.1d93dff3.webp";